import $ from 'jquery'
import isScreenSmall from '../utils';
const { __ } = wp.i18n

import Cookies from 'js-cookie';


var menuBtn = $('.js-menu-button')
$('#menuOffcanvas').on('show.bs.offcanvas', function () {
    menuBtn.addClass('open')
    menuBtn.find('i').removeClass('vn-icons-menu')
    menuBtn.find('i').addClass('vn-icons-close')
    menuBtn.find('.vn-a-content').html(__('Close', 'vn'))
})

$('#menuOffcanvas').on('hide.bs.offcanvas', function () {
    menuBtn.removeClass('open')
    menuBtn.find('i').removeClass('vn-icons-close')
    menuBtn.find('i').addClass('vn-icons-menu')
    menuBtn.find('.vn-a-content').html(__('Menu', 'vn'))
})

$('.js-open-menu').on('click', function () {
    $('.js-main-header').animate({height: 'toggle'})
    $('.js-shop-header').animate({height: 'toggle'})
})

$('.js-close-menu').on('click', function () {
    $('.js-main-header').animate({height: 'toggle'})
    $('.js-shop-header').animate({height: 'toggle'})
})

$('.js-shop-main-header').mouseleave(function(){
    if ( $(window).width() > 992 ) {
        $(this).animate({height: 'toggle'})
        $('.js-shop-header').animate({height: 'toggle'})
    }
});

$('.js-toggle-prices').on('click', function () {
    $(this).toggleClass('dark')
    $('body').toggleClass('vn-hide-prices')
    const tt = $(this).find('.vn-a-icon i');
    tt.toggleClass('vn-icons-euro')
    tt.toggleClass('vn-icons-no-euro')

    if ( Cookies.get('price_hidden') == 'hidden' ) {
        Cookies.remove('price_hidden');
        $(this).find('.vn-a-content').html( __('Hide prices', 'vn') )
    }
    else {
        Cookies.set('price_hidden', 'hidden');
        $(this).find('.vn-a-content').html( __('Show prices', 'vn') )
    }
})

$(document).ready(() => {
    $('.menu-item-has-children').each((e, el) => {
       el.innerHTML = el.innerHTML + '<i class="vn-icons-arrow_downward"></i>'
    })
})

$('.menu-item-has-children').on('click', function () {
    $(this).find('.sub-menu').toggleClass('active')
})

// Vue grandes / petites cards de la boutique. La classe est portée par le conteneur :
// InstantSearch ne réécrit que son contenu, elle survit donc aux re-rendus.
const setProductView = (view) => {
    const isSmall = view === 'small'
    $('.pt-custom-shop__hits').toggleClass('is-small', isSmall)
    $('.js-small-product-view').toggleClass('inactive', !isSmall)
    $('.js-big-product-view').toggleClass('inactive', isSmall)
}

$('.js-big-product-view').on('click', function () {
    localStorage.setItem('product-view', 'big')
    setProductView('big')
})

$('.js-small-product-view').on('click', function () {
    localStorage.setItem('product-view', 'small')
    setProductView('small')
})

if ($('.pt-custom-shop__hits').length) {
    setProductView(localStorage.getItem('product-view'))
}

$('.language-selector').on('click', function(event) {
    event.stopPropagation();
    var $selector = $(this);
    $selector.find('.language-list').toggle();
    $selector.toggleClass('open');
});

$('.language-list li').on('click', function() {
    window.location.href = $(this).attr('data-href');
});

$(document).on('click', function() {
    $('.language-list').hide();
    $('.language-selector').removeClass('open');
});
